// extracted by mini-css-extract-plugin
export default {"accordion":"faq_accordion__zywls","accordionTitle":"faq_accordionTitle__LS3x8","accordionContent":"faq_accordionContent__N43zj","expandIcon":"faq_expandIcon__337Ju"};